export default "__VITE_ASSET__d536f723__"